<template>
    <div>
        <p>
            <button type="button"
                    class="btn mr-2"
                    @click="setAutoRefresh"
                    :disabled="state.loading"
                    :class="{
                        'disabled': state.loading || state.refreshing,
                        'btn-outline-success': !auto_refresh,
                        'btn-success': auto_refresh
                    }">
                <i class="fas fa-circle-notch mr-1 fa-spin" v-if="auto_refresh"></i>
                <i class="fas fa-sync-alt mr-1" v-else></i>
                Auto refresh
            </button>
            <button type="button"
                    class="btn btn-outline-primary"
                    @click="refresh"
                    :disabled="state.loading || state.refreshing"
                    :class="{'disabled': state.loading || state.refreshing }">
                <i class="fas fa-redo mr-1"></i>
                Refresh
            </button>
        </p>

        <spinner class="py-5" v-if="state.loading"/>

        <div class="table-responsive" v-if="!state.loading && logs.length">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th>Date</th>
                        <th>Performer</th>
                        <th>Campaign Status</th>
                        <th>Message</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="log in logs" :class="{ 'table-danger': log.type === 'error' }">
                        <td>{{ log.created_at }}</td>
                        <td>{{ log.performer.nickname }}</td>
                        <td>
                            <campaign-status :status="log.campaign.status"></campaign-status>
                        </td>
                        <td>{{ log.text }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            logs: [],
            auto_refresh: false,
            timer: null,
            state: {
                loading: false,
                refreshing: false,
            }
        };
    },

    methods: {
        setAutoRefresh() {
            this.auto_refresh = !this.auto_refresh;
            this.$emit('auto_refresh', this.auto_refresh);
        },
        stopAutoRefresh() {
            this.auto_refresh = false;
            this.$emit('auto_refresh', this.auto_refresh);
        },
        fetch() {
            return axios.get('/api/campaigns/logs').then(response => {
                this.logs = response.data;
                this.state.loading = false;
                this.state.refreshing = false;
            }).catch(() => {
                this.state.loading = false;
                this.state.refreshing = false;
            });
        },
        refresh() {
            this.state.refreshing = true;
            this.fetch();
        }
    },

    mounted() {
        this.state.loading = true;
        this.fetch();
        this.$on('auto_refresh', (payload) => {
            if (payload) {
                this.timer = setInterval(() => {
                    this.state.refreshing = true;
                    this.fetch();
                }, 5000);
            } else {
                clearInterval(this.timer);
            }
        });
    }
}
</script>
